import React from 'react'
import PropTypes from 'prop-types'

import { facebookLoginApi, facebookLoginApiValidation } from './facebookLoginApi'
import FacebookSignInSDK from './FacebookSignInSDK'
import {
  getModalLoginExtraData,
  isAccountRevalidationExperimentOn,
} from '../../../util/experiments'
import {
  FACEBOOK_LOGIN_METHOD,
  LOGIN_METHOD_KEY,
  MANDATORY_TIPIFICATION_KEY,
} from '../../../util/global.consts'
import storage from '../../../util/storage'
import { isValidMustTypify } from '../../../util/account'

class FacebookSignIn extends React.Component {
  onSuccess = async ({ accessToken }) => {
    const {
      onSuccess,
      onError,
      onRequireEmail,
      onPhoneNotValidatedError,
      onChallengePinCodeCall,
      sessionTokens,
      onAccountNotValidated,
      onAccountMustValidate,
      abTests,
      modalMode,
      lurker,
      onAccountSocialLoginTyping,
      onAccountCompleteData,
    } = this.props

    if (accessToken) {
      const facebookApiCaller = isAccountRevalidationExperimentOn(abTests)
        ? facebookLoginApiValidation(accessToken, null, null, sessionTokens)
        : facebookLoginApi(accessToken, null, null, sessionTokens, abTests)

      const isMustTypify = await isValidMustTypify()

      const extraData = getModalLoginExtraData(abTests, modalMode)

      facebookApiCaller
        .then(async ({ data }) => {
          const { publicAccountId } = data
          lurker.setPublicAccountId(publicAccountId)

          const { remoteAddress, accountJustCreated, accountId, isTypified } = data

          if (accountJustCreated) {
            if (window) {
              const { dataLayer } = window
              if (dataLayer) {
                dataLayer.push({ event: 'facebook_signup_success', user_id: publicAccountId })
              }
            }
            this.viewMessageEvt('facebook_signup_success', {
              remote_addr: remoteAddress,
            })
            this.sendTrackerEvent('sign_up_facebook', {
              remote_addr: remoteAddress,
            })
          } else {
            this.viewMessageEvt('facebook_login_success', {
              remote_addr: remoteAddress,
              accountId: accountId,
              ...extraData,
            })

            if (!isTypified && isMustTypify) {
              return onAccountCompleteData()
            }
          }
          if (typeof onSuccess === 'function') {
            onSuccess({ ...data, method: FACEBOOK_LOGIN_METHOD })
          }
        })
        .catch(error => {
          const { response: { status } = {}, message = 'unknown' } = error
          const { response = {} } = error

          const errorMessage = response?.data?.message
          const type = response?.data?.type

          if (
            errorMessage === 'PHONE_NOT_VALIDATED' &&
            typeof onPhoneNotValidatedError === 'function'
          ) {
            lurker.redirectEvt('phone_validation')

            if (response?.data?.accountJustCreated) {
              lurker.viewMessageEvt('signup_facebook_no_document')
            }

            storage.set(LOGIN_METHOD_KEY, FACEBOOK_LOGIN_METHOD)
            onPhoneNotValidatedError(response?.data?.token)
          } else if (
            errorMessage === 'SOCIAL_TYPIFY' &&
            typeof onAccountSocialLoginTyping === 'function'
          ) {
            const { email, token } = response?.data
            onAccountSocialLoginTyping(email, 'facebook', token)
          } else if (
            errorMessage === 'ACCOUNT_NOT_VALIDATED' &&
            typeof onAccountNotValidated === 'function'
          ) {
            onAccountNotValidated(response?.data?.token)
          } else if (errorMessage === 'PIN_CODE' && typeof onChallengePinCodeCall === 'function') {
            this.viewMessageEvt('facebook_login_2fa', {
              type,
            })
            lurker.redirectEvt('pin_code', {
              type: response.data.type,
            })
            storage.set(LOGIN_METHOD_KEY, FACEBOOK_LOGIN_METHOD)
            onChallengePinCodeCall(response.data)
          } else if (
            errorMessage === 'ACCOUNT_TYPING_REQUIRED' &&
            onAccountCompleteData === 'function'
          ) {
            lurker.viewMessageEvt('error', {
              accounts_reason: errorMessage.toLowerCase(),
              accounts_status_code: status,
              login_type: 'facebook',
            })

            storage.set(MANDATORY_TIPIFICATION_KEY, true)
            onAccountCompleteData(response?.data?.token)
          } else if (
            errorMessage === 'ACCOUNT_MUST_VALIDATE' &&
            typeof onAccountMustValidate === 'function'
          ) {
            onAccountMustValidate(response?.data?.token)
          } else if (status === 422) {
            this.viewMessageEvt('error', {
              reason: 'facebook_no_email_provided',
              accounts_error_code: status,
              ...extraData,
            })
            if (typeof onRequireEmail === 'function') {
              onRequireEmail()
              return
            }
          } else if (status) {
            this.viewMessageEvt('error', {
              reason: 'facebook_unexpected_status_code',
              accounts_status_code: status,
              ...extraData,
            })
          } else {
            this.viewMessageEvt('error', {
              reason: 'facebook_unexpected_error',
              accounts_error_message: message,
              ...extraData,
            })
          }

          if (typeof onError === 'function') {
            onError('api_error')
          }
        })
    }
  }

  onFailure = error => {
    const { code = 'unknown', message = 'unknown' } = error
    const { onError } = this.props
    this.viewMessageEvt('error', {
      reason: code,
      accounts_error_message: message,
    })
    if (typeof onError === 'function') {
      onError(code)
    }
  }

  onCancel = (error = 'unknown') => {
    const { onCancel } = this.props
    this.viewMessageEvt('error', {
      reason: 'facebook_cancelled_by_user',
      accounts_error_message: error,
    })
    if (typeof onCancel === 'function') {
      onCancel()
    }
  }

  onClick = callback => {
    const { onSubmit } = this.props
    return (...args) => {
      this.clickEvt('facebook')
      if (typeof onSubmit === 'function') {
        onSubmit()
      }
      callback(...args)
    }
  }

  viewMessageEvt = (objectDetail, data) => {
    const { lurker } = this.props
    if (lurker && typeof lurker.viewMessageEvt === 'function') {
      lurker.viewMessageEvt(objectDetail, data)
    }
  }

  sendTrackerEvent = (event, data) => {
    const { tracker } = this.props
    if (tracker && typeof tracker.viewMessageEvt === 'function') {
      tracker.viewMessageEvt(event, data)
    }
  }

  clickEvt = objectDetail => {
    const { lurker, abTests, modalMode } = this.props

    if (lurker && typeof lurker.clickEvt === 'function') {
      const extraData = getModalLoginExtraData(abTests, modalMode)
      lurker.clickEvt(objectDetail, extraData)
    }
  }

  render() {
    const { render, facebookAppId } = this.props
    return (
      <FacebookSignInSDK
        facebookAppId={facebookAppId}
        onSuccess={this.onSuccess}
        onError={this.onFailure}
        onCancel={this.onCancel}
        render={({ onClick: callback }) => render({ onClick: this.onClick(callback) })}
      />
    )
  }
}

FacebookSignIn.propTypes = {
  facebookAppId: PropTypes.string,
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  onRequireEmail: PropTypes.func,
  onSubmit: PropTypes.func,
  onSuccess: PropTypes.func,
  render: PropTypes.func.isRequired,
  lurker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  tracker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onPhoneNotValidatedError: PropTypes.func,
  onChallengePinCodeCall: PropTypes.func,
  sessionTokens: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onAccountNotValidated: PropTypes.func,
  onAccountMustValidate: PropTypes.func,
  abTests: PropTypes.string,
  modalMode: PropTypes.bool,
  onAccountSocialLoginTyping: PropTypes.func,
  onAccountCompleteData: PropTypes.func,
}

export default FacebookSignIn
